export default __webpack_public_path__ + "static/karmaFavicon-dc3d13d1fe51820127dca548fefae05c.png";